/** Created by azhou on 2019/3/22.*/
<template>
  <div>
    <public-title>订单评论
      <span class="text-link ml-auto h6" slot="right" @click="$router.back()">返回列表</span>
    </public-title>
    <div class="bg-white p-5">
      <!--订单信息-->
      <div class="mt-2 mb-3 text-left">
        <label class="text-muted mr-5">订单编号：
          <span class="text-blue">{{queryCon.orderType == 8 ? CommentDetail.info.oid : CommentDetail.oid}}</span>
        </label>
        <label class="text-muted" v-show="CommentDetail.title">团号：<span class="text-blue">{{CommentDetail.title}}</span></label>
      </div>
      <!--预订成功的酒店-->
      <div class="comment-wrap border mb-4" v-for="(hotelItem,hotelIndex) in cList" :key="hotelIndex">
        <!--酒店名称-->
        <div class="mb-3 text-left d-flex align-items-center">
          <img v-if="queryCon.orderType == 8" v-lazy="ImgPreUrl + hotelItem.pic[0]"
              height="60" width="60" style="border-radius: 50%;"/>
          <img v-else :src="hotelItem.pic?ImgPreUrl+hotelItem.pic:'/static/images/public/defaultImg.png'"
              height="60" width="60" style="border-radius: 50%;"/>
          <h5 class="ml-2 mb-0">{{hotelItem.hotel_name || hotelItem.appoint_name}}</h5>
        </div>
        <!--icon评分-->
        <div class="mb-2">
          <div class="d-flex align-items-center mb-2">
            <div class="form-left-text" style="width: 110px;">服务态度：</div>
            <div class="d-flex justify-content-between align-items-center w-100 h5">
            <span class="icon-comment-atti" :data-value="iconItem.value" v-for="(iconItem,iconIndex) in iconList"
                  @click="setGrade('.icon-comment-atti',hotelIndex,iconIndex)" :key="iconIndex">
              <i class="iconfont mr-1" v-html="iconItem.icon"></i>{{iconItem.title}}
            </span>
            </div>
          </div>
          <div class="d-flex align-items-center mb-2">
            <div class="form-left-text" style="width: 110px;">环境设施：</div>
            <div class="d-flex justify-content-between align-items-center w-100 h5">
            <span class="icon-comment-envi" :data-value="iconItem.value" v-for="(iconItem,iconIndex) in iconList"
                  @click="setGrade('.icon-comment-envi',hotelIndex,iconIndex)" :key="iconIndex">
              <i class="iconfont mr-1" v-html="iconItem.icon"></i>{{iconItem.title}}
            </span>
            </div>
          </div>
        </div>
        <!--文字评论-->
        <left-text-border class="mt-3" type="textarea" v-model="commentLists[hotelIndex].comment" placeholder="请输入您的评论（请勿超过85字）"/>
        <!--上传图片-->
        <upload-image class="mt-3" @fileChange="(imgs)=>{commentLists[hotelIndex].comment_pic = imgs;}" 
          :maxLength="5" editMode/>
        <el-button class="mt-3" type="success" @click="submitCommit">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions, mapState} from 'vuex'
  import {UploadImages} from '@/assets/utils/uploadFiles'

  export default {
    name: 'CommentPost',
    computed: {
      ...mapState(['CommentDetail']),
      ...mapGetters(['userInfo','brand']),
      queryCon() { return this.$route.query },
      cList () {
        if (this.queryCon.orderType == 8) return new Array(this.CommentDetail.info)
        else return this.CommentDetail.data
      }
    },
    data() {
      return {
        orderRes: {},
        iconList: [
          {value: '1', icon: '&#xe647;', title: '极差'}, {value: '2', icon: '&#xe664;', title: '差'}, {
            value: '3',
            icon: '&#xe6f8;',
            title: '一般'
          },
          {value: '4', icon: '&#xe67a;', title: '满意'}, {value: '5', icon: '&#xe94c;', title: '非常满意'},
        ],
        commentLists: [{}]
      }
    },
    async mounted() {
      await this.getPostCommentDetail(this.queryCon);
      this.formatCommentList()
      $(() => {
        /*默认选中非常满意*/
        this.commentLists.forEach((item, index) => {
          this.setGrade('.icon-comment-atti', index, 4);
          this.setGrade('.icon-comment-envi', index, 4);
        });
      });
    },
    methods: {
      ...mapActions(['getPostCommentDetail', 'commentPost']),
      /*设置服务态度和环境设施*/
      setGrade(slec, hotelIndex, iconIndex) {
        let iconTarget = $('.comment-wrap').eq(hotelIndex).find(slec).eq(iconIndex);
        iconTarget.addClass('activeIcon');
        iconTarget.siblings().removeClass('activeIcon');
        if (slec === '.icon-comment-atti') {
          this.commentLists[hotelIndex].hotel_environment = iconTarget.data('value')
        } else if (slec === '.icon-comment-envi') {
          this.commentLists[hotelIndex].hotel_facilities = iconTarget.data('value')
        }
      },
      /*发送后台的评论数组*/
      formatCommentList() {
        this.commentLists = this.cList.map(item => {
          return {
            hotel_environment: '5',
            hotel_facilities: '5',
            comment: '',
            comment_pic: [],
            reply_store_id: item.hotel_id || item.homestay_id,
            reply_store_type: this.queryCon.orderType,
          };
        })
      },
      /*提交评论*/
      submitCommit() {
        if (!this.$GFUN.powerIsInArray([260])) { this._alert('您没有相关权限！',null,'error'); return; }
        this._confirm('确定发布该评论么？', async () => {
          for (let i = 0; i < this.commentLists.length; i++) {
            let v = this.commentLists[i];
            v.comment_pic = await UploadImages(v.comment_pic);
            v.comment_pic = v.comment_pic.join(',');
            if (this.queryCon.orderType == 8) v.reply_store_id = this.cList[0].appoint
          }
          this.commentPost({
            oid: this.queryCon.orderId,
            order_type: this.queryCon.orderType,
            comment_list: this.commentLists
          })
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .comment-wrap {
    border-radius: 15px;
    padding: 30px 10%;
    .icon-comment-atti, .icon-comment-envi {
      cursor: pointer;
      i {
        font-size: 16px;
      }
      &:hover {
        i {
          color: #ffc107;
        }
      }
    }
    .activeIcon {
      color: #ffc107;
    }
  }
</style>
